@if (show$ | async) {
  <div class="fixed inset-0 flex items-center justify-center z-9999 bg-surface-bg-dim-white">
    <p-progress-spinner />
  </div>
}
